// Local imports
import { PAGE_VARS } from '../page/vars.js';
import { enum_value } from '../util/enumtool.js';
import {
    getParameterByName,
    getCookie,
    setMotCodeInputValue,
    setMotCodeCookie,
} from './index.js';

export function motcode_cookie_handler(global) {
    let motcode = getParameterByName(global);
    if (motcode) {
        setMotCodeCookie(motcode);
    }

    let cookieMotcode = getCookie('mot_code');
    let cookieSiteName = getCookie('siteName');
    let siteName = enum_value(PAGE_VARS.kind);

    // If the mot code in the cookie is not from an OGC page
    // and we're on an OGC page, we return out and do not apply
    // the cookie mot code to the product
    if (siteName === 'OGC' && cookieSiteName !== 'OGC') {
        return;
    }

    // Get the motcode input element. This class is used on OGC pages
    let motCodeInputElement = global.document.querySelector('.motcode-input');
    // If motCodeInputElement is null, then we check for the ODN motcode input id field
    if (!motCodeInputElement) {
        motCodeInputElement = global.document.getElementById('mot_codeInput');
    }

    if (cookieMotcode && cookieMotcode.length > 0 && motCodeInputElement) {
        setMotCodeInputValue(global, cookieMotcode);
    }
}
